function jsonFetcher(element, api) {
    $.get(api, function(data) {
        socialFeedRenderer(data, element);
    });
}

function socialFeedRenderer(data, element) {
    element.innerHTML = "";
    var template = document.querySelector('.json-fetcher__template');

    var keys = element.dataset.keys.split(';');

    data.data.forEach(function (item) {
        var templateClone = template.cloneNode(true);
        keys.forEach(function (key) {
            try {
                var keyParts = key.split('.');
                var index = 0;
                var data = item;
                while (index + 1 <= keyParts.length) {
                  data = data[keyParts[index]];
                  index += 1;
                }

                if (key === 'photo' && item.media_type === 'video') {
                  // Replace with video
                  templateClone.querySelector(
                    '.visual',
                  ).innerHTML = '<video width="260" height="260" autoplay loop muted><source src="' + data + '" type="video/mp4"></video>';
                } else {
                  templateClone.innerHTML = templateClone.innerHTML.replace(`__${key}__`, data);
                }
            } catch (error) {
                console.error(error);
            }
        });
        templateClone.innerHTML = templateClone.innerHTML.replace('data-src', 'src');
        element.appendChild(templateClone.children[0]);
    });

    // var buttonPrev = $('<button data-api="'+ data.links.prev + '">prev</button>');
    // if (!data.links.prev) {
    //     buttonPrev.attr('disabled', 'disabled');
    // }

    // var buttonNext = $('<button data-api="'+ data.links.next + '">next</button>');
    // if (!data.links.next) {
    //     buttonNext.attr('disabled', 'disabled');
    // }

    // var holder = $(element);
    // console.log(holder);

    // var buttonHolder = $('<div class="button-holder"></div>');

    // buttonHolder.append(buttonPrev);
    // buttonHolder.append(buttonNext);

    // holder.append(buttonHolder);

    // buttonPrev.click(function() {
    //     jsonFetcher(element, buttonPrev.data('api'));
    //     window.scroll({
    //         top: 0,
    //         left: 0,
    //         behavior: 'smooth'
    //       });
    // })

    // buttonNext.click(function() {
    //     jsonFetcher(element, buttonNext.data('api'));
    //     window.scroll({
    //         top: 0,
    //         left: 0,
    //         behavior: 'smooth'
    //       });
    // })

}

var jsonHolder = document.querySelector('.json-fetcher');

if (jsonHolder) {
  jsonFetcher(jsonHolder, jsonHolder.dataset.api);
}

